import { computed, reactive, ref } from 'vue';

import { acceptHMRUpdate, defineStore } from 'pinia';
import { useFormStatusStore } from '@/Stores'

import { useNProgress } from '@vueuse/integrations/useNProgress';
import { get } from '@/Helpers/takeLatestResponseRequest';

export const useClientInvoiceShiftStore = defineStore('clientInvoiceShift', () => {
    const formStatusStore = useFormStatusStore()

    const { isLoading } = useNProgress()
    const loading = ref(isLoading)

    const shiftDict = reactive({})

    function replaceLocalStoreClientShifts(client_id, shifts) {
        shiftDict[client_id] = shifts
    }

    function computedClientShift(client_id) {
        return computed(() => shiftDict[client_id] ? shiftDict[client_id] : [])
    }

    function computedClientShiftMap(client_id) {
        return computed(() => {
            const map = {}

            if (shiftDict[client_id]) {
                shiftDict[client_id].forEach((shift, index) => {
                    map[shift.id] = index
                })
            }

            return map
        })
    }

    async function retrieveShifts(client_id, lowerBoundDate, upperBoundDate, formId) {
        loading.value = true
        if (formId) {
            formStatusStore.addLoading(formId)
        }

        return await new Promise((resolve, reject) => {
            get(
                `/api/v1/clients/${client_id}/invoice-shifts`,
                {
                    params: {
                        start_date: lowerBoundDate,
                        end_date: upperBoundDate
                    }
                },
            ).then(response => {
                resolve(response)
            }).catch((err) => {
                if (err?.canceled) {
                    return
                }
                reject({ "error": err })
            }).finally(() => {
                loading.value = false
                if (formId) {
                    formStatusStore.removeLoading(formId)
                }
            })
        });
    }

    return {
        retrieveShifts, replaceLocalStoreClientShifts,
        computedClientShift, computedClientShiftMap
    }

})

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useClientInvoiceShiftStore, import.meta.hot))
}
